<div class="header-container">
  <div class="floating-pane">

    <div class="app-logo-container">
      <img src="../assets/images/app-logo-header.png" [style.height.px]="20" alt="logo">
    </div>

    <div *ngIf="config$ | async as config" class="header-content">
      <h1>
        {{getReportTitle(config)}}
        <span *ngIf="hasChanges(config)" class="header-content--changeindicator"><sup>* report has unsaved changes</sup></span>
      </h1>

      <div *ngIf="showOldReportGenerator && oldTemplates && oldTemplates.length > 0" class="legacy-report-generator">
        <mat-form-field>
          <mat-label>Choose Template</mat-label>
          <mat-select [(ngModel)]="selectedTemplate">
            <mat-option *ngFor="let template of oldTemplates" [value]="template">
              {{ template.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button mat-raised-button [disabled]="!selectedTemplate" (click)="generateLegacyReport(config)">
          Legacy Report
        </button>
      </div>

      <div class="header-actions" *ngIf="(progress$ | async) as progress">
        <button mat-raised-button (click)="configurePdf()">{{ configureReportText() }}</button>
        <button mat-raised-button color="primary" [disabled]="generateReportDisabled(config)" (click)="generatePdfReport(config, progress.status)">{{ getGenerateReportText(config, progress) }}</button>
      </div>
    </div>

  </div>
</div>